<template>
  <v-app id="home" style="scroll-behavior: auto; overflow: hidden;">
    <basic-alert :active="alertActive" :type="alertType" :msg="alertMsg" />
    <vue-splash
      :show="splashTime"
      :logo="logo"
      title=""
      color="#005591"
      :size="300"
      :fixed="true"
    />
    <v-main v-if="!splashTime" class="background-home">
      <view-container>
        <auto-container :scrollY="true" color="#F7F9F9" dimension="92" footer>
          <v-container>
            <h1
              v-text="'Reglamento'"
              class="itemsCenter"
            />
            <v-row class="mb-6" justify="center">
              <v-col cols="12" md="12" class="padding-b0 padding-t10">
                <div v-html="regulation.descripcion" />
              </v-col>
            </v-row>
          </v-container>
          <template v-slot:footer>
            <v-row class="alignText" style="padding: 2vh">
              <v-col align-self="center" cols="2">
                <basic-btn block icon="mdi-arrow-left" @click="logout" />
              </v-col>
              <v-col cols="10">
                <basic-btn block text="Aceptar" @click="accept" />
              </v-col>
            </v-row>
          </template>
        </auto-container>
      </view-container>
    </v-main>
  </v-app>
</template>

<script>
import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
  BasicAlert,
} from "@/components";
import { logo } from "@/assets";
import { services } from "@/utils";

export default {
  name: "home",
  components: {
    AutoContainer,
    ViewContainer,
    BasicInput,
    BasicBtn,
    BasicAlert,
  },
  data: () => ({
    splashTime: true,
    alertActive: false,
    alertMsg: "",
    alertType: "error",
    regulation: {},
    logo: logo,
  }),
  mounted() {
    this.validRegulation();
  },
  watch: {
    alertActive(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertActive = false;
        }, 3000);
      }
    },
  },
  methods: {
    validRegulation() {
      services
        .ws("get", "lastPublish")
        .then((res) => {
          if (res.ok) {
            this.regulation = res.data;
            if (JSON.stringify(this.regulation) === '{}') {
              this.$router.push("/client/Search");
            }
          } else {
            this.logout();
          }
        })
        .catch((error) => {
          this.codeError = error.response.data.code;
          this.error = true;
          this.logout();
        })
        .finally(() => {
          if (this.regulation.aceptado) {
            this.$router.push("/client/Search");
          }
          this.splashTime = false;

          this.loading = false;
        });
    },
    logout() {
      if (this.$session.exists()) {
        let jwt = this.$session.get("jwt");
        let headers = {
          Authorization: "Bearer " + jwt,
        };
        this.axios
          .post(services.routes.logout, null, { headers })
          .then(() => {
            this.$session.destroy();
            this.$router.push("/");
          })
          .catch(() => {
            this.$session.destroy();
            this.$router.push("/");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push("/");
      }
    },
    accept() {
      let data = {
        data: {
          reglamentoID: this.regulation.reglamentoID,
        },
      };
      services
        .ws("post", "acceptRegulation", data)
        .then((res) => {
          if (res.ok) {
            this.$router.push({
              path: "/client/Search",
              query: {
                alertType: "success",
                alertMsg: "Reglamento aceptado.",
              },
            });
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}
.padding-t0 {
  padding-top: 0px;
}
.padding-t10 {
  padding-top: 10%;
}
.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
h1 {
  color: #005591;
}
</style>
